export enum EFilterTypes {
  FIXED_INCOME = 'fixed-income',
  VARIABLE_INCOME = 'variable-income'
}
